/**
 * @description: 第三方邮件推送代码，命名全局变量，ts重写（mailchimp）
 */
export default function presetVariable() {
    if (typeof window === 'undefined') return;
    const win: any = window;
    win.fnames = ['EMAIL', 'FNAME', 'LNAME', 'ADDRESS', 'PHONE'];
    win.ftypes = ['email', 'text', 'text', 'address', 'phone'];
    win.$mcj = win.jQuery.noConflict(true);
}
